<template>
  <div class="reviews_container reviews_container_static">
    <p class="top_tastes_text color_grey-black">отзывы</p>
    <div class="reviems_block">
      <div class="reviems_case">
        <div class="reviems_img_block">
          <img
            class="rewiewsstatic_img"
            src="@/assets/img/rewiews1.png"
            alt=""
          />
          <p class="reviems_text_img">
            BelVaping Обзоры, новости, статьи, информация о вейпинге
          </p>
        </div>
        <div class="reviems_text_block">
          <p class="reviems_name">Обзор жидкостей DAY & NIGHT</p>
          <p class="reviems_text">
            Главная концепция линейки довольно любопытная и одновременно
            необычная. Всего представлено 24 различных не повторяющихся вкуса.
            Половина из них озаглавлена как DAY и сделана на крепком никотине.
            Это жидкости для парения днём, когда нужно максимальное удовольствие
            от парения и ударную дозу никотина в моменте. Вторая половина
            называется NIGHT — эта часть уже предназначена для парения вечером и
            ночью, когда вы уже в расслабленном состоянии просто наслаждаетесь
            вкусом. Никотин уже не такой агрессивный, а значит можно сделать
            больше затяжек под любимый сериал. <br /><br />
            Стоит признать, вкусы в линейке DAY & NIGHT простые, можно даже
            сказать в большинстве элементарные, но хорошо сбалансированные и
            приятные (на исключение в виде Колы внимание не обращаем, бывает).
            Серия NIGHT отлично парится, хоть под сериал ночью, хоть целый день.
            Серия DAY по ощущениям кажется значительно крепче и быстрее насыщает
            организм никотином.
          </p>
          <div class="reviems_text_block_links">
            <p class="reviems_author">Автор: Денис Лещёв</p>
            <a class="" href=""><p class="reviems_text_link reviems_text_img">Подробнее</p></a>
          </div>
        </div>
      </div>
      <div class="reviems_case">
        <div class="reviems_img_block">
          <img
            class="rewiewsstatic_img"
            src="@/assets/img/rewiews2.png"
            alt=""
          />
          <p class="reviems_text_img">
            VapeNews дайджест — главные новости индустрии
          </p>
        </div><div class="reviems_text_block">
        <p class="reviems_name">
          DAY & NIGHT: обзор жидкостей от компании Seven Star
        </p>
        <p class="reviems_text">
          Итак, к нам приехали жидкости для электронных сигарет в количестве 12
          штук: 6 из них носят название NIGHT и имеют крепость 2%, то есть 20
          мг/мл солевого никотина, и соотношение PG/VG — 50/50. Остальные 6
          жидкостей называются DAY и отличаются крепостью — она составляет 5%
          или 50 мг/мл. Соотношение PG/VG такое же — 50/50.<br /><br />
          У упаковок и флаконов максимально простой и минималистичный дизайн:
          однотонные серые слова нанесены на градиенты, цвета которых можно
          отнести к ароматике каждой конкретной жидкости. Этикетки флаконов
          максимально повторяют упаковку. <br /><br />
          Хочется сказать, что при парении жидкостей для электронных сигарет
          линейки DAY сразу ощущается throat hit. Все вкусы, кроме «Винограда»,
          можно назвать удачными и оценить довольно высоко. Что касается линейки
          NIGHT, то стоит отметить, что в жидкостях нет холодка, поэтому тем,
          кто его не любит, эта серия может зайти. Также здесь отсутствует
          throat hit, и парить жидкость достаточно легко. Аромат «Кола-лимон»
          можно назвать действительно стоящим, а вот «Черника» получилась не
          самой выдающейся.
        </p>
        <div class="reviems_text_block_links">
        <p class="reviems_author">Автор: Kate</p>
        <a class="" href=""><p class="reviems_text_link reviems_text_img">Подробнее</p></a></div>
      </div>
    </div>
  </div></div>
</template>
